module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v("\n                            " + _vm._s(_vm.flashMessage) + "\n                        ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.cityId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicle.cityId),
      expression: "vehicle.cityId"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "cityId",
      "disabled": (_vm.$route.params && _vm.$route.params._id && _vm.$route.params._id != '0') || _vm.isCityDisable
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vehicle, "cityId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select City Name")]), _vm._v(" "), _vm._l((_vm.citys), function(cityId) {
    return _c('option', {
      domProps: {
        "value": cityId.id
      }
    }, [_vm._v(_vm._s(cityId.name) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "cityId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.vNumber),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Vehicle Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicle.vNumber),
      expression: "vehicle.vNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "13",
      "type": "text",
      "name": "vNumber",
      "required": "",
      "placeholder": "Vehicle Number",
      "pattern": "^[A-Z]{2}[ -][0-9]{1,2}(?: [A-Z])?(?: [A-Z]*)? [0-9]{4}$"
    },
    domProps: {
      "value": (_vm.vehicle.vNumber)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicle, "vNumber", $event.target.value)
      }, function($event) {
        _vm.vehicle.vNumber = _vm.vehicle.vNumber.toUpperCase()
      }]
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "vNumber",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                                            Vehicle Number is a required field\n                                        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("\n                                            Enter the valid vehicle number [Eg:- DL 00 XX 0000].\n                                        ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.vMakeYear),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("Make Year")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "not-after": _vm.disabledAfter,
      "id": "vMakeYear",
      "lang": "en",
      "name": "vehicleMakeYear",
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.vehicle.vMakeYear),
      callback: function($$v) {
        _vm.$set(_vm.vehicle, "vMakeYear", $$v)
      },
      expression: "vehicle.vMakeYear"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "vMakeYear",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Make Year is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Make Year is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.vModelName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Model Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicle.vModelName),
      expression: "vehicle.vModelName"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "25",
      "type": "text",
      "name": "vModelName",
      "placeholder": "Model Name",
      "pattern": "^[^0-9][a-zA-Z0-9 ]{0,25}[^\\s]$"
    },
    domProps: {
      "value": (_vm.vehicle.vModelName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicle, "vModelName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "vModelName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Model Name is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("\n                                            Alphabets/Numbers are allowed.\n                                        ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.assignGpsId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Assign GPS ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicle.assignGpsId),
      expression: "vehicle.assignGpsId"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "25",
      "type": "text",
      "name": "assignGpsId",
      "placeholder": "Assign GPS ID",
      "pattern": "^(?!\\s)(?![\\s\\S]*\\s$)[a-zA-Z0-9\\s]{0,25}$"
    },
    domProps: {
      "value": (_vm.vehicle.assignGpsId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicle, "assignGpsId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "assignGpsId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                                            Assign GPS ID is a required field\n                                        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("\n                                            Alphabets/Numbers are allowed.\n                                        ")])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'vehicles'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                                Cancel\n                            ")])]), _vm._v(" "), (_vm.$route.params && _vm.$route.params._id == '0') ? _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.createVehicles
    }
  }, [_vm._v("\n                            Save\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.$route.params && _vm.$route.params._id != '0') ? _c('button', {
    staticClass: "btn gradientbt mr-5",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.updateVehicles
    }
  }, [_vm._v("\n                            Update\n                        ")]) : _vm._e()], 1)], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-93942ce6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93942ce6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/vehicle/vehicleCreates.vue
// module id = 2367
// module chunks = 0